<mat-sidenav-container class="sidenav authorization-scheme-filter">
  <mat-sidenav #sidenav [opened]="model.open" mode="over" fixedInViewport="true" position="end">
    <div fxFlex="100" fxLayout="column" xLayoutAlign="space-between stretch">

      <div #header [ngClass]="{'mat-card' : isScrolled }" class="sidenav-header" fxFlex="none" fxLayout="row"
        fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <div class="icon-back c-pointer" aria-label="Back" (click)="close()" fxLayout="row"
            fxLayoutAlign="center center">
            <mat-icon>keyboard_arrow_left</mat-icon>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
            <div class="fc-9 fs-18 c-pointer h-medium mr-2" (click)="close()">
              {{ 'flows.detail.editFlow' | translate}} /
            </div>
            <div class="title">{{ 'flows.detail.autorizationscheme' | translate}}</div>
          </div>
        </div>
        <div class="close h-medium" (click)="close()" color="warn" fxLayoutAlign="center center">
          <mat-icon aria-hidden="false" aria-label="Filter">close</mat-icon>
        </div>
      </div>
      <div #content (scroll)="onContentScroll($event);" class="sidenav-content filter-content" fxFlex
        *ngIf="model.services.length == 0">
        <mat-card appearance="outlined" class="card-alert">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
            <mat-icon class="ic-svg-6">payment</mat-icon>
            <span class="fc-6">{{ 'flows.detail.autorization.warning.authRequired' | translate}}
              <a href="https://dev.tuna.uy/console/flows/#authorization-scheme" target="_blank">{{
                'flows.detail.autorization.warning.learnMore' | translate}}</a>
            </span>
          </div>
        </mat-card>
        <mat-card appearance="outlined">
          <div fxLayout="row" fxLayoutAlign="start center">
            <div>
              <img src="assets/images/illustration/auth-schemes-empty-state.svg" class="auth-schemes" width="225"
                height="214" />
            </div>
            <div fxLayout="column">
              <div class="fs-30 fc-0 mb-2">{{ 'flows.detail.autorization.emptyState.title' | translate}}
              </div>
              <div class="fs-18 fc-6 mb-4">
                {{ 'flows.detail.autorization.emptyState.title' | translate}}
              </div>
              <div>
                <button mat-flat-button color="primary" class="h-medium" (click)="goToService()">
                  <span>{{ 'flows.detail.autorization.emptyState.action' | translate}}</span>
                </button>
              </div>
            </div>
          </div>
        </mat-card>
      </div>
      <div #content (scroll)="onContentScroll($event);" class="sidenav-content filter-content" fxFlex
        *ngIf="model.services.length > 0">
        <mat-card appearance="outlined" class="card-alert">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
            <mat-icon class="ic-svg-6">payment</mat-icon>
            <span class="fc-6">{{ 'flows.detail.autorization.warning.authRequired' | translate}}
              <a href="https://dev.tuna.uy/console/flows/#authorization-scheme" target="_blank">{{
                'flows.detail.autorization.warning.learnMore' | translate}}</a>
            </span>
          </div>
        </mat-card>
        <mat-card appearance="outlined" class="card-edit">
          <mat-card-header fxLayout="row" fxLayoutAlign="space-between center">
            <mat-card-title fxLayout="row" fxLayoutAlign="start center">
              <div class="pin-icon" *ngIf="is_default == true">
                <mat-icon class="ic-svg-white ic-20" svgIcon="icon_push_pin"></mat-icon>
              </div>
              <span class="scheme-name" #name>{{ model.authorization_scheme.name }}</span>

              <mat-form-field class="add-name" *ngIf="name.hidden">
                <input autoSizeInput matInput [hidden]="!name.hidden" [(ngModel)]="model.authorization_scheme.name"
                  #edit (keyup.enter)="inputNameKeyupEnter($event)">
              </mat-form-field>

              <button class="btn-edit" fxLayout="row" fxLayoutAlign="center center"
                (click)="editStep($event); name.hidden = false" mat-icon-button fxShow fxHide.lt-md="true"
                *ngIf="name.hidden">
                <mat-icon class="icon-edit" svgIcon="icon_check"></mat-icon>
              </button>

              <button class="btn-edit" fxLayout="row" fxLayoutAlign="center center" mat-icon-button fxShow
                fxHide.lt-md="true" (click)="name.hidden = true; clickEditName()" *ngIf="!name.hidden">
                <mat-icon class="icon-edit" svgIcon="icon_edit"></mat-icon>
              </button>

            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="auth-scheme" fxLayout="column" fxShow fxHide.lt-md
              *ngIf="model.authorization_scheme.steps.length > 0">
              <div fxFlexFill *ngIf="model.authorization_scheme">
                <div class="auth-scheme-row" fxLayout="column"
                  *ngFor="let step of model.authorization_scheme.steps; let last = last; let first = first; let index = index;">
                  <div class="fc-9 mb-3" fxLayout="row" *ngIf="first">
                    <div fxFlex="20">
                      {{ 'flows.detail.autorization.attempt' | translate }}
                    </div>
                    <div fxFlex="20">
                      <span>
                        {{ 'flows.detail.autorization.retry' | translate}}
                      </span>
                    </div>
                    <div fxFlex="20">
                      <span>
                        {{ 'flows.detail.autorization.second_retry' | translate }}
                      </span>
                    </div>
                    <div fxFlex="20">
                      <span>
                        {{ 'flows.detail.autorization.traffic' | translate}}
                      </span>
                    </div>

                  </div>
                  <div fxLayout="row" fxFlex fxLayoutAlign="start center">
                    <div class="col" fxFlex="20" fxLayout="column">
                      <!-- <div class="item-selected" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="5px"
                        *ngIf="step.first_service.custom_name ">
                        <div class="c-pointer" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px"
                          *ngIf="step.first_service.image_path">
                          <img class="service-logo" src="{{step.first_service.image_path}}">
                        </div>
                        <div class="fs-14 fc-6">{{step.first_service.custom_name}}
                        </div>
                      </div> -->
                      <div class="item-selected" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="5px"
                        *ngIf="step.first_service">
                        <div class="c-pointer" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px"
                          *ngIf="step.first_service.image_path" [matMenuTriggerFor]="menu">
                          <img class="service-logo" src="{{step.first_service.image_path}}">
                          <mat-icon class="icon-pointer ic-svg-9">keyboard_arrow_down
                          </mat-icon>
                        </div>
                        <div class="fs-14 fc-6">{{step.first_service.custom_name}}
                        </div>
                      </div>
                      <div fxLayout="column" fxLayoutAlign="center start">
                        <div fxLayout="row">
                          <button fxLayout="row" fxLayoutAlign="start center" class="btn-add"
                            [disabled]="!model.authorization_scheme.can_edit"
                            [ngClass]="{'c-pointer': model.authorization_scheme.can_edit }" [matMenuTriggerFor]="menu"
                            *ngIf="!step.first_service.custom_name">
                            <mat-icon>add_circle_outline</mat-icon>
                            <span>{{ 'flows.detail.autorization.addService' |
                              translate}}</span>
                          </button>
                          <mat-menu class="services-selector" #menu="matMenu">
                            <button mat-menu-item disableRipple *ngFor="let service of step.first_service.services;"
                              [ngClass]="{'selected': service.addFirst}"
                              (click)="service.addFirst ?
                                                                            removeServiceFirst(step) : addServiceFirst( step, service, index)">
                              <div class="service-option" fxLayout="row" fxLayoutAlign="space-between center">
                                <div fxLayout="column" fxLayoutAlign="start start">
                                  <img class="service-logo mt-2" [ngClass]="formatPartnerClass(service.service_name)"
                                    [src]="service.image_path" (error)="updateUrl(service)" />
                                  <div class="fs-14 fc-6 pt-2">{{service.custom_name}}
                                  </div>
                                </div>
                                <mat-icon class="ic-svg-green" *ngIf="!service.addFirst ">
                                  add_circle_outline</mat-icon>
                                <mat-icon *ngIf="service.addFirst ">
                                  delete_outline
                                </mat-icon>
                              </div>
                            </button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                    <div class="col" fxFlex="20" fxLayout="column">
                      <!-- <div class="item-selected" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="5px"
                        *ngIf="step.second_service.custom_name ">
                        <div class="c-pointer" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px"
                          *ngIf="step.second_service.image_path">
                          <img class="service-logo" src="{{step.second_service.image_path}}">
                        </div>
                        <div class="fs-14 fc-6">{{step.second_service.custom_name}}
                        </div>
                      </div> -->
                      <div class="item-selected" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="5px"
                        *ngIf="step.second_service.custom_name">
                        <div class="c-pointer" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px"
                          *ngIf="step.second_service.image_path" [matMenuTriggerFor]="menu2">
                          <img class="service-logo" src="{{step.second_service.image_path}}">
                          <mat-icon class="icon-pointer ic-svg-9">keyboard_arrow_down
                          </mat-icon>
                        </div>
                        <div class="fs-14 fc-6">{{step.second_service.custom_name}}
                        </div>
                      </div>
                      <div fxLayout="column" fxLayoutAlign="center start">
                        <div fxLayout="row">
                          <button fxLayout="row" fxLayoutAlign="start center" class="btn-add"
                            [ngClass]="{'c-pointer': model.authorization_scheme.can_edit }" [matMenuTriggerFor]="menu2"
                            *ngIf="!step.second_service.custom_name ">
                            <mat-icon>add_circle_outline</mat-icon>
                            <span>{{ 'flows.detail.autorization.addService' |
                              translate}}</span>
                          </button>
                          <mat-menu class="services-selector" #menu2="matMenu">
                            <button mat-menu-item disableRipple *ngFor="let service of step.second_service.services"
                              [ngClass]="{'selected': service.addSecond }"
                              (click)="service.addSecond ? removeServiceSecond(step) : addServiceSecond(step, service)">
                              <div class="service-option" fxLayout="row" fxLayoutAlign="space-between center">
                                <div fxLayout="column" fxLayoutAlign="start start">
                                  <img class="service-logo mt-2" [src]="service.image_path" width="auto" height="30"
                                    (error)="updateUrl(service)" />
                                  <span class="fs-14 fc-6 pt-2">{{service.custom_name}}</span>
                                </div>
                                <mat-icon class="ic-svg-green">
                                  add_circle_outline</mat-icon>
                                <mat-icon *ngIf="service.addSecond">
                                  delete_outline
                                </mat-icon>
                              </div>
                            </button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                    <div class="col" fxFlex="20" fxLayout="column">
                      <!-- <div class="item-selected" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="5px"
                        *ngIf="step.third_service.custom_name ">
                        <div class="c-pointer" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px"
                          *ngIf="step.third_service.image_path">
                          <img class="service-logo" src="{{step.third_service.image_path}}">
                        </div>
                        <div class="fs-14 fc-6">{{step.third_service.custom_name}}
                        </div>
                      </div> -->

                      <div class="item-selected" fxLayout="column" fxLayoutGap="5px"
                        *ngIf="step.third_service.custom_name " [matMenuTriggerFor]="menu3">
                        <div class="c-pointer" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px"
                          *ngIf="step.third_service.image_path">
                          <img class="service-logo" src="{{step.third_service.image_path}}">
                          <mat-icon class="icon-pointer ic-svg-9">keyboard_arrow_down
                          </mat-icon>
                        </div>
                        <div class="fs-14 fc-6">{{step.third_service.custom_name}}
                        </div>
                      </div>

                      <div fxLayout="column" fxLayoutAlign="center start">
                        <div fxLayout="row">
                          <button fxLayout="row" fxLayoutAlign="start center" class="btn-add"
                            [matMenuTriggerFor]="menu3"
                            [ngClass]="{'c-pointer': model.authorization_scheme.can_edit }"
                            *ngIf="!step.third_service.custom_name">
                            <mat-icon>add_circle_outline</mat-icon>
                            <span>{{ 'flows.detail.autorization.addService' |
                              translate}}</span>
                          </button>
                          <mat-menu class=" services-selector" #menu3="matMenu">
                            <button mat-menu-item disableRipple *ngFor="let service of step.third_service.services"
                              [ngClass]="{'selected': service.addThird }"
                              (click)="service.addThird ? removeServiceThird(step) : addServiceThird(step, service)">
                              <div class="service-option" fxLayout="row" fxLayoutAlign="space-between center">
                                <div fxLayout="column" fxLayoutAlign="start start">
                                  <img class="service-logo mt-2" [src]="service.image_path" width="auto" height="30"
                                    (error)="updateUrl(service)" />
                                  <span class="fs-14 fc-6 pt-2">{{service.custom_name}}</span>
                                </div>
                                <mat-icon class="ic-svg-green" *ngIf="!service.addThird ">
                                  add_circle_outline</mat-icon>
                                <mat-icon *ngIf="service.addThird ">
                                  delete_outline
                                </mat-icon>
                              </div>
                            </button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                    <div class="col" fxFlex fxLayout="column">


                      <mat-form-field class="allocation-input" hideRequiredMarker="true">
                        <input #allocationField matInput type="number" autoSizeInput [(ngModel)]="step.percentage"
                          maxlength="100" minlength="0" (keyup)="valid()">
                        <span class="percentage">%</span>
                      </mat-form-field>

                      <div class="allocation-slider" fxLayout="column" fxFlex="100">
                        <mat-slider color="primary" [max]="max" [min]="min" [step]="step" [discrete]="thumbLabel"
                          fxFlex="100" [showTickMarks]="showTicks">
                          <input matSliderThumb [(ngModel)]="step.percentage" #slider (change)="valid()">
                        </mat-slider>
                      </div>

                      <div class="ruler fs-10 fc-9" fxLayout="row" fxLayoutAlign="space-between center">
                        <div fxFlex class="stick" fxLayoutAlign="start center">
                          <div>0%</div>
                        </div>
                        <div fxFlex class="stick" fxLayoutAlign="start center">
                          <div>20%</div>
                        </div>
                        <div fxFlex class="stick" fxLayoutAlign="start center">
                          <div>40%</div>
                        </div>
                        <div fxFlex class="stick" fxLayoutAlign="start center">
                          <div>60%</div>
                        </div>
                        <div fxFlex class="stick" fxLayoutAlign="start center">
                          <div>80%</div>
                        </div>
                        <div fxFlex class="stick last" fxLayoutAlign="start center">
                          <div>100%</div>
                        </div>
                      </div>

                      <div class="allocation-validation" fxFlex>
                        <div class="validation-error fc-red fs-12 text-right" fxLayout="row" fxLayoutAlign="end center"
                          *ngIf="canShowErrorSum && last">
                          {{ 'flows.detail.autorization.actions.error' | translate}}
                        </div>
                      </div>





                      <!-- <mat-form-field class="allocation-input" hideRequiredMarker="true">
                                                <input #allocationField autoSizeInput matInput type="text"
                                                    [twoDigitDecimaNumber]="true" [(ngModel)]="step.percentage" maxlength="100"
                                                    minlength="0" (keyup)="valid()" [disabled]="!model.authorization_scheme.can_edit">
                                                <span *ngIf="model.authorization_scheme.can_edit" (click)="allocationField.select(); valid(); " matSuffix
                                                    class="icon-edit c-pointer">
                                                    <mat-icon class="ic-svg-9" svgIcon="icon_edit"></mat-icon>
                                                </span>
                                            </mat-form-field>
                                            <div class="allocation-slider" fxLayout="column" fxFlex="100">
                                                <!-- TODO - Adicionar atributo 'color="warn"' quando o somatório não for 100% -->
                      <!-- TODO: The 'tickInterval' property no longer exists -->
                      <!-- <mat-slider [(ngModel)]="step.percentage" color="primary" step="5" fxFlex="100"
                                                    aria-label="allocation" [disabled]="!model.authorization_scheme.can_edit" #ngSlider><input matSliderThumb (change)="valid()" #ngSliderThumb="matSliderThumb" />
                                                </mat-slider>
                                                <div class="ruler fs-10 fc-9" fxLayout="row"
                                                    fxLayoutAlign="space-between center">
                                                    <div fxFlex class="stick">
                                                        <div>0%</div>
                                                    </div>
                                                    <div fxFlex class="stick">
                                                        <div>20%</div>
                                                    </div>
                                                    <div fxFlex class="stick">
                                                        <div>40%</div>
                                                    </div>
                                                    <div fxFlex class="stick">
                                                        <div>60%</div>
                                                    </div>
                                                    <div fxFlex class="stick last" fxLayoutAlign="space-between start">
                                                        <div>80%</div>
                                                        <div>100%</div>
                                                    </div>
                                                </div>
                                                <div class="allocation-validation" fxFlex>
                                                    <div class="validation-error fc-red fs-12 text-right" fxLayout="row" fxLayoutAlign="end center" *ngIf="canShowErrorSum && last">
                                                        {{ 'flows.detail.autorization.actions.error' | translate}}
                                                    </div>
                                                </div>
                                            </div> -->
                      <!-- TODO - Regra para exibir validação do campo quando o somatório não for 100% -->
                      <!-- <div class="mat-error pt-1">The sum of traffic allocation must complete 100%</div> -->



                    </div>
                    <div class="col pl-2" fxFlex="20" fxLayout="row" fxLayoutAlign="start center">
                      <div class="ml-4" fxLayout="column">
                        <button mat-mini-fab disableRipple class="icon-button" fxLayout="row"
                          fxLayoutAlign="center center" (click)="removeRow(step)" *ngIf="!first t">
                          <mat-icon>delete_outline</mat-icon>
                        </button>
                      </div>
                      <div class="ml-4" fxLayout="column">
                        <div class="c-pointer" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px"
                          (click)="addRow()" *ngIf="last">
                          <button mat-mini-fab disableRipple class="icon-button" fxLayout="row"
                            fxLayoutAlign="center center">
                            <mat-icon>add</mat-icon>
                          </button>
                          <div class="fc-9">{{ 'flows.detail.autorization.addNewRow' |
                            translate}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <!-- Modificacoes de flows -->

            <!-- <div class="pt-5">
              <mat-card class="flow-card">
                <div class="flow-header">
                  <mat-icon
                  aria-hidden="false"
                  aria-label="services"
                  svgIcon="icon_hardware"
                >
                </mat-icon>
                  <span>As modificações afetarão os seguintes fluxos:</span>
                </div>
                <ul class="flow-list">
                  <li *ngFor="let flow of flows">
                    <span>{{ flow.name }}</span>
                    <span class="status">
                      <span class="bullet success"></span>
                      {{ flow.status }}
                    </span>
                  </li>
                </ul>
              </mat-card>
            </div> -->

          </mat-card-content>
          <mat-card-footer fxLayout="row" fxLayoutAlign="space-between center">
            <div>

            </div>
            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
              <div class="fc-6 fs-12 text-right" fxFlex="240px">
                {{ 'flows.detail.autorization.actions.editAlert' | translate}}
              </div>
              <button fxLayoutAlign="end center" fxLayoutAlign.lt-md="center center" mat-flat-button
                [disabled]="invalid" color="primary" (keydown.enter)="save()" (click)="save()">
                {{ 'flows.detail.autorization.actions.save' | translate}}
              </button>
            </div>
          </mat-card-footer>
        </mat-card>
      </div>
    </div>
  </mat-sidenav>
  <mat-sidenav-content [style.display]="'none'"></mat-sidenav-content>
</mat-sidenav-container>
